export const suppressEmployerOnboardingBankInfo = true;
export const suppressInviteEmailLink = false;
export const validateEmployeeEmailLength = false;
export const disableEmployeeEdit = false;
export const employerCustodianInfoTemplate = "";
export const displayBankAccountHolds = false;